var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRankingStarDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6016 2.44531C11.8477 2.5 11.957 2.80078 11.7656 2.99219L10.7266 4.00391L10.9727 5.42578C11 5.67188 10.7539 5.86328 10.5078 5.75391L9.25 5.07031L7.96484 5.75391C7.71875 5.86328 7.47266 5.67188 7.5 5.42578L7.74609 4.00391L6.70703 2.99219C6.51562 2.80078 6.625 2.5 6.87109 2.44531L8.32031 2.25391L8.94922 0.941406C9.08594 0.695312 9.41406 0.722656 9.52344 0.941406L10.1523 2.25391L11.6016 2.44531ZM11 7.75C11.4648 7.75 11.875 8.16016 11.875 8.625V13.875C11.875 14.3672 11.4648 14.75 11 14.75H7.5C7.00781 14.75 6.625 14.3672 6.625 13.875V8.625C6.625 8.16016 7.00781 7.75 7.5 7.75H11ZM4.875 9.5C5.33984 9.5 5.75 9.91016 5.75 10.375V13.875C5.75 14.3672 5.33984 14.75 4.875 14.75H1.375C0.882812 14.75 0.5 14.3672 0.5 13.875V10.375C0.5 9.91016 0.882812 9.5 1.375 9.5H4.875ZM12.75 12.125C12.75 11.6602 13.1328 11.25 13.625 11.25H17.125C17.5898 11.25 18 11.6602 18 12.125V13.875C18 14.3672 17.5898 14.75 17.125 14.75H13.625C13.1328 14.75 12.75 14.3672 12.75 13.875V12.125Z",
    fill: "#909BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingStarDark);
export default __webpack_public_path__ + "static/media/ranking-star-dark.60430c407795e0ba79781139d42b1a4e.svg";
export { ForwardRef as ReactComponent };